export default __webpack_public_path__ + "static/media/logo-horizontal.74dd67a6.svg";